const MILLISECOND_UNIT = 1000;
const MINUTES_MILLISECONDS_CAL_FORMULA = 60 * MILLISECOND_UNIT;
const HOURS_MILLISECONDS_CAL_FORMULA = 60 * MINUTES_MILLISECONDS_CAL_FORMULA;

/**
 *
 * @param ms: number
 * @returns number (seconds)
 */
const millisecondsToSeconds = (ms: number) => {
  return Math.floor(ms / MILLISECOND_UNIT);
};

/**
 *
 * @param s: number
 * @returns number (ms)
 */
const secondsToMilliseconds = (s: number) => {
  return s * MILLISECOND_UNIT;
};

/**
 *
 * @param ms: number
 * @returns number (minutes)
 */
const millisecondsToMinutes = (ms: number) => {
  return Math.floor(ms / MINUTES_MILLISECONDS_CAL_FORMULA);
};

/**
 *
 * @param m: number
 * @returns number (ms)
 */
const minutesToMilliseconds = (m: number) => {
  return m * MINUTES_MILLISECONDS_CAL_FORMULA;
};

/**
 *
 * @param ms: number
 * @returns number (hours)
 */
const millisecondsToHours = (ms: number) => {
  return Math.floor(ms / HOURS_MILLISECONDS_CAL_FORMULA);
};

/**
 *
 * @param h: number
 * @returns number (ms)
 */
const hoursToMilliseconds = (h: number) => {
  return h * HOURS_MILLISECONDS_CAL_FORMULA;
};

/**
 *
 * @param ms: number
 * @returns string `${minutes}:${seconds}` (ex. 04:25, 03:02, 333:04)
 */
const millisecondsToMinutesAndSeconds = (ms: number) => {
  const minutes = millisecondsToMinutes(ms);
  const seconds = Math.floor((ms % MINUTES_MILLISECONDS_CAL_FORMULA) / MILLISECOND_UNIT);

  const displayMinutes = `${minutes < 10 ? `0${minutes}` : minutes}:`;
  const displaySeconds = `${seconds < 10 ? `0${seconds}` : seconds}`;

  return `${displayMinutes}${displaySeconds}`;
};

/**
 *
 * @param ms: number
 * @returns string `${hours}:${minutes}:${seconds}` (ex. 00:04:25, 10:03:02, 01:22:30)
 */
const millisecondsToTime = (ms: number) => {
  const hours = millisecondsToHours(ms);
  const minutes = Math.floor(
    (ms % HOURS_MILLISECONDS_CAL_FORMULA) / MINUTES_MILLISECONDS_CAL_FORMULA,
  );
  const seconds = Math.floor((ms % MINUTES_MILLISECONDS_CAL_FORMULA) / MILLISECOND_UNIT);

  const displayHours = `${hours < 10 ? `0${hours}` : hours}:`;
  const displayMinutes = `${minutes < 10 ? `0${minutes}` : minutes}:`;
  const displaySeconds = `${seconds < 10 ? `0${seconds}` : seconds}`;

  return `${displayHours}${displayMinutes}${displaySeconds}`;
};

export {
  MILLISECOND_UNIT,
  MINUTES_MILLISECONDS_CAL_FORMULA,
  HOURS_MILLISECONDS_CAL_FORMULA,
  millisecondsToMinutes,
  millisecondsToMinutesAndSeconds,
  millisecondsToSeconds,
  millisecondsToHours,
  hoursToMilliseconds,
  secondsToMilliseconds,
  minutesToMilliseconds,
  millisecondsToTime,
};
